import videojs from 'video.js';

class PreventDirectActionsWithTech extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player, options);
		player.on('ready', () => {
			player.tech().el().insertAdjacentElement('afterend', videojs.dom.createEl('div', {className: 'vjs-plug'}));
		});
	}
}

videojs.registerPlugin('preventDirectActionsWithTech', PreventDirectActionsWithTech);

